class Template {
    constructor(scope, htmlString, containerId) {
        this.container = scope.document.createElement('div');
        this.container.id = containerId;
        this.container.innerHTML = htmlString;

        this.__fragment = scope.document.createDocumentFragment();
        this.__fragment.appendChild(this.container);
    }

    render(parent) {
        parent.appendChild(this.__fragment);
    }

    replace(htmlString) {
        this.container.innerHTML = htmlString;
    }

    destroy() {
        this.container.parentNode.removeChild(this.container);
    }

    byId(elementId) {
        return this.container.querySelector('#' + elementId);
    }
}

export {Template};
